import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5b8e6026"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "coupon_details"
};
const _hoisted_2 = {
  class: "base_details_content"
};
const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "定时类型", -1));

const _hoisted_5 = {
  class: "base_details_content_second"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "基本信息", -1));

const _hoisted_7 = {
  class: "base_details_content_second"
};
const _hoisted_8 = {
  class: "base_details_date_picker"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "优惠券设置", -1));

const _hoisted_10 = {
  class: "base_details_content_second"
};
const _hoisted_11 = {
  class: "base_screen_header"
};
const _hoisted_12 = {
  class: "dialog-footer"
};
import BackTitleView from "@com/BackTitleView.vue";
import { ref, reactive } from "vue";
import { $box, $msg } from "@ui/msg";
import $ from "@util/base";
import api from "@api/couponTiming";
import couponApi from "@api/coupon";
import useRoute from "@util/router";
import DataCollectTable from "@/components/table/DataCollectTable.vue";
import { COLUMN_TYPE, OP_KEY, OPERATIONS, operationsHander } from "@/components/table/tableOperations";
import { Search } from "@element-plus/icons-vue";
export default {
  __name: 'CouponTimingDetails',

  setup(__props) {
    const tagsOptions = ref([]);
    getConfig();

    function getConfig() {
      api.tagsList(val => {
        tagsOptions.value = val;
      });
    }

    const route = useRoute();
    const urlQuery = route.query();
    var readOnly = false;
    var title = "定时发放详情";
    $.handleCRU(urlQuery.type, {
      show: () => {
        readOnly = true;
        title = "定时发放详情";
        getData();
      },
      add: () => {
        title = "新增定时发放";
      },
      modify: () => {
        title = "新增定时编辑";
        getData();
      }
    }); //定时类型

    const typeOptions = [{
      label: "新客有礼",
      value: "1062001"
    }, {
      label: "会员日",
      value: "1062002"
    }];
    const addCouponDialog = ref(false);
    const dataForm = ref({
      name: null,
      date: [],
      startDate: null,
      endDate: null,
      type: '1062001',
      pushTime: null,
      peopleType: null,
      phone: [],
      phones: null,
      couponItemList: [],
      dateType: 0
    });
    const dataFormRules = {
      name: [{
        required: true,
        message: "请输入名称",
        trigger: "blur"
      }],
      date: [{
        required: true,
        message: "请选择注册时间",
        trigger: "blur"
      }],
      pushTime: [{
        required: true,
        message: "请选择发布日期",
        trigger: "blur"
      }],
      phones: [{
        required: true,
        message: "请输入手机号",
        trigger: "blur"
      }],
      couponItemList: [{
        required: true,
        message: "请选择优惠券",
        trigger: "blur"
      }]
    };
    const couponName = ref("");
    const couponDataTableRef = ref(null);
    const couponData = ref([]);
    const couponDataConfig = ref({
      showIndex: true,
      showSelection: true,
      column: [{
        label: "名称",
        prop: "name",
        width: 200
      }, {
        label: "已发放",
        prop: "provideNum",
        width: 100
      }, {
        label: "已核销",
        prop: "usedNum",
        width: 100
      }, {
        label: "当前状态",
        prop: "enableStatusName",
        width: 100
      }, {
        label: "有效范围",
        prop: "lifespan"
      }, {
        label: "优惠内容",
        prop: "couponDesc"
      }, {
        label: "创建时间",
        prop: "createTime"
      }, {
        label: "创建人",
        prop: "creator",
        width: 100
      }]
    });
    const couponDataSize = ref(10);
    const couponDataPage = ref(1);
    const couponDataTotal = ref(0);
    const couponDataHandler = operationsHander();
    const couponItemListHandler = operationsHander();
    const couponItemListConfig = ref({
      showIndex: true,
      operations: {
        label: '操作',
        width: 200,
        operations: getOperations
      },
      column: [{
        label: "名称",
        prop: "couponName",
        width: 200
      }, {
        label: "已发放",
        prop: "provideNum",
        width: 100
      }, {
        label: "已核销",
        prop: "usedNum",
        width: 100
      }, {
        label: "有效范围",
        prop: "lifespan"
      }, {
        label: "优惠内容",
        prop: "couponDesc"
      }, {
        label: "创建时间",
        prop: "createTime"
      }, {
        label: "创建人",
        prop: "creator",
        width: 100
      }, {
        label: "数量",
        prop: "num",
        // type: COLUMN_TYPE.input,
        // operationsKey: OPERATIONS.input,
        width: 100
      }]
    });

    function getOperations(data) {
      return [OPERATIONS.del];
    }

    couponItemListHandler.install(OP_KEY.delete, (data, row) => {
      $box.open("移除", "确认移除优惠券：" + data.couponName, () => {
        let index = dataForm.value.couponItemList.findIndex(e => {
          return e.couponCode === data.couponCode;
        });
        dataForm.value.couponItemList.splice(index, 1);
      });
    });

    function check() {
      if (readOnly) {
        route.go(-1);
        return;
      }

      let nData = $.deepCopy(dataForm.value);

      if (nData.type === '1062001') {
        nData.startDate = nData.date[0];
        nData.endDate = nData.date[1];
      }

      if (nData.type === '1062002') {
        if (nData.peopleType === 2) {
          if (!nData.phones) {
            $msg.error("请输入手机号");
            return;
          } else {
            nData.phone = nData.phones.split(",");
          }
        }
      }

      if (nData.couponItemList.length === 0) {
        $msg.error("请选择优惠券");
        return;
      } else {
        nData.couponItemList.some(e => {
          if (!e.num) {
            $msg.error("请输入数量");
            return true;
          }
        });
        nData.couponItemList = nData.couponItemList.map((e, index) => {
          return {
            couponCode: e.couponCode,
            sort: index + 1,
            num: 1
          };
        });
      }

      $.handleCRU(urlQuery.type, {
        add: () => {
          api.add(nData, () => {
            $msg.succ("保存成功");
            route.go(-1);
          });
        },
        modify: () => {
          api.update(nData, () => {
            $msg.succ("保存成功");
            route.go(-1);
          });
        }
      });
    }

    function getData() {
      api.details(urlQuery.code, val => {
        if (val.startDate && val.endDate) {
          val.date = [val.startDate, val.endDate];
        }

        if (val.couponItemList) {
          val.couponItemList = val.couponItemList.map(e => {
            if (!e.num) {
              e.num = 1;
            }

            return e;
          });
        }

        if (val.type == '1062002' && val.peopleType == 2) {
          if (val.phone) {
            val.phones = val.phone.join(",");
          }
        }

        dataForm.value = val;
      });
    }

    function showAddCouponDialog() {
      getCouponData();
      addCouponDialog.value = true;
    }

    function getCouponData() {
      couponApi.list({
        name: couponName.value,
        page: couponDataPage.value,
        size: couponDataSize.value
      }, val => {
        couponData.value = val.list;
        couponDataTotal.value = val.total;
      });
    }

    function couponDataPageChange(type, val) {
      if (type == 'page') {
        couponDataPage.value = val;
      } else if (type == 'size') {
        couponDataSize.value = val;
      }

      getCouponData();
    }

    function couponDataSelectedSubmit() {
      let selected = couponDataTableRef.value.getSelectData();

      if ($.isEmpty(selected)) {
        $msg.error("请选择优惠券");
        return;
      } else {
        selected = selected.filter(f => {
          return !dataForm.value.couponItemList.some(s => {
            return s.couponCode === f.couponCode;
          });
        }).map(e => {
          return {
            couponCode: e.couponCode,
            couponName: e.name,
            provideNum: e.provideNum,
            usedNum: e.usedNum,
            lifespan: e.lifespan,
            couponDesc: e.couponDesc,
            createTime: e.createTime,
            creator: e.creator,
            sort: e.sort,
            num: 1
          };
        });
        dataForm.value.couponItemList = dataForm.value.couponItemList.concat(selected);
        addCouponDialog.value = false;
      }
    }

    return (_ctx, _cache) => {
      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: _unref(title)
        }, null, 8, ["title"]), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_form, {
            ref: "basicFormRef",
            disabled: _unref(readOnly),
            model: dataForm.value,
            rules: dataFormRules,
            "label-width": "100px",
            class: "base_details_form"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "",
              prop: "type"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: dataForm.value.type,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dataForm.value.type = $event)
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(typeOptions, (item, index) => {
                  return _createVNode(_component_el_radio, {
                    key: index,
                    label: item.value
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                    _: 2
                  }, 1032, ["label"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["disabled", "model"])]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_form, {
            ref: "basicFormRef",
            disabled: _unref(readOnly),
            model: dataForm.value,
            rules: dataFormRules,
            "label-width": "100px",
            class: "base_details_form"
          }, {
            default: _withCtx(() => [dataForm.value.type === '1062002' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: " ",
              prop: "peopleType"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: dataForm.value.dateType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dataForm.value.dateType = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio, {
                  label: 0
                }, {
                  default: _withCtx(() => [_createTextVNode("指定日期")]),
                  _: 1
                }), _createVNode(_component_el_radio, {
                  label: 1
                }, {
                  default: _withCtx(() => [_createTextVNode("每年")]),
                  _: 1
                }), _createVNode(_component_el_radio, {
                  label: 2
                }, {
                  default: _withCtx(() => [_createTextVNode("每月")]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
              label: "名称",
              prop: "name"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: dataForm.value.name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dataForm.value.name = $event),
                placeholder: "请输入"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), dataForm.value.type === '1062001' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: "注册时间",
              prop: "date"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_date_picker, {
                modelValue: dataForm.value.date,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dataForm.value.date = $event),
                type: "daterange",
                "range-separator": "~",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])])]),
              _: 1
            })) : _createCommentVNode("", true), dataForm.value.type === '1062002' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              label: "发布日期",
              prop: "pushTime"
            }, {
              default: _withCtx(() => [dataForm.value.dateType === 0 ? (_openBlock(), _createBlock(_component_el_date_picker, {
                key: 0,
                modelValue: dataForm.value.pushTime,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => dataForm.value.pushTime = $event),
                type: "datetime",
                placeholder: "选择日期时间",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])) : _createCommentVNode("", true), dataForm.value.dateType === 1 ? (_openBlock(), _createBlock(_component_el_date_picker, {
                key: 1,
                modelValue: dataForm.value.pushTime,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => dataForm.value.pushTime = $event),
                type: "datetime",
                placeholder: "选择日期时间",
                format: "MM-DD",
                "value-format": "MM-DD"
              }, null, 8, ["modelValue"])) : _createCommentVNode("", true), dataForm.value.dateType === 2 ? (_openBlock(), _createBlock(_component_el_date_picker, {
                key: 2,
                modelValue: dataForm.value.pushTime,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => dataForm.value.pushTime = $event),
                type: "datetime",
                placeholder: "选择日期时间",
                format: "DD",
                "value-format": "DD"
              }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]),
              _: 1
            })) : _createCommentVNode("", true), dataForm.value.type === '1062002' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              label: "人员设置",
              prop: "peopleType"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: dataForm.value.peopleType,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => dataForm.value.peopleType = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio, {
                  label: 1
                }, {
                  default: _withCtx(() => [_createTextVNode("全部用户")]),
                  _: 1
                }), _createVNode(_component_el_radio, {
                  label: 2
                }, {
                  default: _withCtx(() => [_createTextVNode("指定用户")]),
                  _: 1
                }), _createVNode(_component_el_radio, {
                  label: 3
                }, {
                  default: _withCtx(() => [_createTextVNode("指定标签")]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true), dataForm.value.type == '1062002' && dataForm.value.peopleType == '2' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 4,
              label: "手机号",
              prop: "phones"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                autosize: "",
                type: "textarea",
                modelValue: dataForm.value.phones,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => dataForm.value.phones = $event),
                placeholder: "请输入手机号，多个使用','分隔"
              }, null, 8, ["modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true), dataForm.value.type == '1062002' && dataForm.value.peopleType == '3' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 5,
              label: "标签",
              prop: "tags"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: dataForm.value.tags,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => dataForm.value.tags = $event),
                placeholder: "请选择标签",
                clearable: ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagsOptions.value, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["disabled", "model"])]), _hoisted_9, _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_form, {
            ref: "basicFormRef",
            disabled: _unref(readOnly),
            model: dataForm.value,
            rules: dataFormRules,
            "label-width": "100px",
            class: "base_details_form"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              onClick: showAddCouponDialog,
              type: "primary"
            }, {
              default: _withCtx(() => [_createTextVNode("添加优惠券")]),
              _: 1
            }), _createVNode(DataCollectTable, {
              ref: "couponItemListTableRef",
              data: dataForm.value.couponItemList,
              config: couponItemListConfig.value,
              isRoute: false,
              onOperationsHander: _unref(couponItemListHandler).receive,
              isPage: false
            }, null, 8, ["data", "config", "onOperationsHander"])]),
            _: 1
          }, 8, ["disabled", "model"])])])])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: _cache[10] || (_cache[10] = $event => _unref(route).go(-1))
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }), !_unref(readOnly) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: check,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("保存 ")]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        title: "添加产品",
        modelValue: addCouponDialog.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => addCouponDialog.value = $event),
        width: "80%",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_12, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: couponDataSelectedSubmit
        }, {
          default: _withCtx(() => [_createTextVNode("保存")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: _cache[13] || (_cache[13] = $event => addCouponDialog.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_form, {
          inline: true,
          class: "base_search_form",
          onSubmit: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: couponName.value,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => couponName.value = $event),
              "onKeyup[native]": getCouponData,
              onChange: getCouponData,
              placeholder: "优惠券名称",
              clearable: "",
              "suffix-icon": _unref(Search)
            }, null, 8, ["modelValue", "suffix-icon"])]),
            _: 1
          })]),
          _: 1
        })]), _createVNode(DataCollectTable, {
          ref_key: "couponDataTableRef",
          ref: couponDataTableRef,
          data: couponData.value,
          config: couponDataConfig.value,
          isRoute: false,
          onOperationsHander: _unref(couponDataHandler).receive,
          total: couponDataTotal.value,
          onPageChange: couponDataPageChange
        }, null, 8, ["data", "config", "onOperationsHander", "total"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};